import styled from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 20px;
`;
export const Description = styled.label`
  all: unset;
  color: ${({ theme }) => theme.colors.gray};
  flex: 1;
  font-size: 14px;
  line-height: 20px;
  padding-right: 100px;
`;
export const Title = styled.strong`
  display: block;
  font-weight: 600;
`;
export const Control = styled.div`
  margin-left: auto;
`;

export const BadgeWrapper = styled.span`
  display: inline-block;
  margin-left: 5px;
`;
